import { Directive } from '@angular/core';

@Directive({
	// eslint-disable-next-line @angular-eslint/directive-selector
	selector: '[footerContent]',
	standalone: true,
})
export class FooterContentDirective {}
